/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';

/**
 * Minimal payload for adding a household family member (a `Member` with
 * `MemberType.FamilyMember` linked to PrimaryMemberId).
 * @export
 * @interface WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto
 */
export interface WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto
     */
    primaryMemberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
    /**
     * 
     * @type {Array<number>}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto
     */
    groups?: Array<number> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDtoFromJSON(json: any): WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto {
    return WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'primaryMemberId': !exists(json, 'primaryMemberId') ? undefined : json['primaryMemberId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
    };
}

export function WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDtoToJSON(value?: WebApiServicesDataTransferObjectsGroupServiceAddFamilyMemberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'primaryMemberId': value.primaryMemberId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
        'groups': value.groups,
    };
}

